<script>
  import {onMount} from 'svelte';
  import {debounce, getChartSizes} from './settings';
  import BarsHorizontal from "./BarsHorizontal.svelte";
  import BarsVertical from "./BarsVertical.svelte";
  export let data = [];
  let width = [];
  let maxVal = null;

  let chartProps = [];
  let tags = [];

  const getMaxVal = () => {
    if (data.length < 2) {
      return null;
    }
    let allData = [];
    data.forEach(d => {
      allData = allData.concat(d.meloni.map(m => m.count)).concat(d.schlein.map(s => s.count));
    });
    return Math.max(...allData);
  };

  const draw = () => {
    data.forEach((d, i) => {
      chartProps[i] = getChartSizes(Math.max(d.meloni.length, d.schlein.length), width[i]);
      tags[i] = d.tags.map(t => (`<em>#${t}</em>`));
    });
  };

  const debouncedSetWindowWidth = debounce(draw, 500);

  onMount(async () => {
    window.addEventListener('resize', debouncedSetWindowWidth);
    maxVal = getMaxVal();
    draw();
		return () => {
			window.removeEventListener('resize', debouncedSetWindowWidth);
		}
  });
</script>

<div class="cardMultiple">
  {#each data as chart, index}
    <div class="card" id="card--multiple--{chart.id}">
      {#if chart.title}
        <div class="card--multiple--header">
          <h4>{chart.title}</h4>
        </div>
      {/if}
      <div class="card--multiple--chart" bind:offsetWidth={width[index]}>
        {#if chartProps[index]?.orientation === 'horizontal'}
          <BarsHorizontal chartProps={chartProps[index]} data={data[index]} {maxVal} />
        {/if}
        {#if chartProps[index]?.orientation === 'vertical'}
          <BarsVertical chartProps={chartProps[index]} data={data[index]} {maxVal}/>
        {/if}
      </div>
      <div class="card--multiple--tags">Keywords: {@html tags[index]?.join(', ')}.</div>
    </div>
  {/each}
</div>

<style>
  .cardMultiple {
    display: flex;
    flex-wrap: nowrap;
    margin: 40px -20px 0 -20px; 
    overflow-x: auto;
    overflow-y: hidden;
  }

  .cardMultiple .card {
    flex: 0 0 90%;
    margin: 0;
    max-width: 90%;
    padding: 0 20px 20px 20px;
    scroll-snap-type: x mandatory;
  }

  .card--multiple--tags {
    font-family: 'Fira Mono', monospace;
    font-size: 12px;
    font-weight: 500;
    padding: 0 10px;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
  }

  @media screen and (min-width: 1024px) {
    .cardMultiple {
      align-items: flex-start;
      justify-content: space-between;
      overflow: visible;
      position: relative;
    }

    .cardMultiple .card {
      flex: 0 0 48%;
      padding: 0;
    }

    .cardMultiple::before {
      background: var(--notsodark);
      bottom: 0;
      content: '';
      height: auto;
      left: 50%;
      position: absolute;
      top: 0;
      width: 1px;
    }
  }
</style>